import React from 'react'
import { Typography, TextField, FormHelperText } from '@mui/material'
import ValidationErrorText from '../common/ValidationErrorText'

const TextEditor = ({ label, value, onChange, placeholder, readOnly = false,fieldError }) => {
  return (
    <>
      <Typography fontSize="14px" fontWeight="500" mb={1}>
        {label}
      </Typography>
      <TextField
        value={value}
        onChange={e => !readOnly && onChange(e.target.value)}
        placeholder={placeholder || "Type here..."}
        multiline
        minRows={6}
        fullWidth
        variant="outlined"
        readOnly={readOnly}
        disabled={readOnly}
        sx={{
          width: '100%',
          maxWidth: '100%',
        }}
      />
      <ValidationErrorText error={fieldError}/>
    </>
  )
}

export default TextEditor
